<script>
import {CODE} from "@/model/code";
import {PATH} from "@/constants";

export default {
  name: "TotalCodeOptions",
  data() {
    return {
      systemGroupCodeOptions: [],
      groupCompanyOptions: [],
      countryCodeOptions: [],
      approvedYnOptions: [],
      cmsUseYnOptions: [],
      taxYnOptions: [],
      reasonCodeOptions: [],
      doneReasonCodeOptions: [],
      asReceiptTypeOptions: [],
      workorderStateOptions: [],
      workorderStaffOptions: [],
      // CMS 상태
      cmsStateOptions: [],
      // 세금계산서
      autoIssueYnOptions: [],
      // 계약상태
      useYnOptions: [],
      // 결제일 및 계산시작일
      billDayOnlyNumberOptions: [],
      // 지도표시
      mapYnOptions: [],
      // 지불방법
      payTypeOptions: [],
      // 프린터 상태 코드
      printerStateOptions: [],
      // 무한잉크 여부
      unlimitedInkYnOptions: [],
      // 토너 사용 여부
      pmChkTonerOptions: [],
      // 드럼 사용 여부
      pmChkDrumOptions: [],
      // 계약 여부
      isPrinterContractOptions: [],
      // 모니터링 여부
      isMonitoringPrinterOptions: [],
      // 출고 여부
      installStatusOptions: [],
      deviceInstallStatusOptions: [],
      // 장치 구분
      deviceTypeOptions: [],
      newDeviceTypeOptions: [],
      // 접속 상태
      connectionStatusOptions: [],
      asOptions: {
        reasonCodeOptions: undefined,
        doneReasonCodeOptions: undefined,
        asReceiptTypeOptions: undefined,
        workorderStateOptions: undefined,
        workorderStaffOptions: undefined,
      },
      countryOptions: [],
      popOptions: [],
      sortOptions: [],
      languageOptions: [],
      noticeTypeOptions: [],
      noticeDetailOptions: [],
      faqTypeOptions: [],
      faqDetailOptions: [],
      batchOptions: [],
      paymentMethodOptions: [],
      paymentStatusOptions: [],
      cmsOptions: [],
      salesTypeOptions: [],
      companyOptions: [],
      commandTypeOptions: [],
      deleteYnOptions: undefined,
      deviceDeleteYnOptions: undefined,
      rentalCompanyGroupOptions: [], // 입대업체 그룹 옵션
      isLoading: false,
      defaultYnOptions: [],
      usageYnOptions: [
        {codeValue: this.t('전체'), codeKey: null},
        {codeValue: this.t('최종본'), codeKey: 'Y'},
        {codeValue: this.t('이전본'), codeKey: 'N'},
      ],
    }
  },
  computed: {
    /**
     * A/S 기사에서 '선택 안함' 옵션이 추가되었습니다.
     */
    workorderStaffOptionsWithNull() {
      return [{userId: null, userFullname: this.$translate("배정취소")}].concat(this.workorderStaffOptions);
    },
  },
  created() {
  },
  methods: {
    loadDefaultYnOptions() {
      this.defaultYnOptions.splice(0, this.defaultYnOptions.length)
      this.defaultYnOptions.push(
        {codeValue: this.t('사용'), codeKey: 'Y'}
      )
      this.defaultYnOptions.push(
        {codeValue: this.t('미사용'), codeKey: 'N'},
      )
    },

    async loadSystemGroupCodeOptions() {
      const res = await this.$request(PATH.SYSTEM_PERMISSION_GROUP.LIST_BY_SYSTEM)
        .post()
        .enqueue();
      this.systemGroupCodeOptions = res.data;
    },

    /**
     * 번역을 위하여 사용가능한 모든 언어를 서버에서 로드합니다.
     */
    async loadAllLanguages() {
      const res = await this.$request(PATH.CODE.ALL_LANGUAGE)
        .post()
        .enqueue();
      this.languageOptions = res.data;
    },

    async loadCountryOptions() {
      this.countryOptions = [
        {codeKey: 'KR', codeValue: '한국'},
        {codeKey: 'US', codeValue: '미국'},
        {codeKey: 'CN', codeValue: '중국'},
        {codeKey: 'TW', codeValue: '대만'},
        {codeKey: 'RU', codeValue: '러시아'},
      ];
    },

    async loadnoticePopOptions() {
      this.popOptions = [
        {codeKey: true, codeValue: '게시중'},
        {codeKey: false, codeValue: '게시 안함'},
      ];
    },

    async loadNoticeSortOptions() {
      this.sortOptions = [
        {codeKey: CODE.NOTICE_SORT.GENERAL, codeValue: '일반'},
        {codeKey: CODE.NOTICE_SORT.REFERENCE, codeValue: '자료실'},
        {codeKey: CODE.NOTICE_SORT.UPDATE, codeValue: '업데이트'},
        {codeKey: CODE.NOTICE_SORT.PRODUCT_INFORMATION, codeValue: '제품정보'},
        {codeKey: CODE.NOTICE_SORT.INDUSTRY_TRENDS, codeValue: '업계동향'},
      ];
    },

    async loadGroupCompanyOptions() {
      this.groupCompanyOptions = [
        {codeValue: this.t('MBOX'), codeKey: 'MBOX'},
      ];
    },

    async loadCountryCodeOptions() {
      this.countryCodeOptions = [
        {codeValue: this.t('대한민국'), codeKey: 'KR'},
        {codeValue: this.t('미국'), codeKey: 'US'},
        {codeValue: this.t('중국'), codeKey: 'CN'},
        {codeValue: this.t('러시아'), codeKey: 'RU'},
        {codeValue: this.t('대만'), codeKey: 'TW'},
      ];
    },

    async loadApprovedYnOptions() {
      this.approvedYnOptions = [
        {codeValue: this.t('승인'), codeKey: 'Y'},
        {codeValue: this.t('미승인'), codeKey: 'N'},
      ];
    },

    async loadCmsUseYnOptions() {
      this.cmsUseYnOptions = [
        {codeValue: this.t('사용'), codeKey: 'Y'},
        {codeValue: this.t('미사용'), codeKey: 'N'},
      ];
    },

    async loadTaxYnOptions() {
      this.taxYnOptions = [
        {codeValue: this.t('사용'), codeKey: 'Y'},
        {codeValue: this.t('미사용'), codeKey: 'N'},
      ];
    },

    /**
     * AS접수증상 로드
     */
    async loadOptionsForReasonCode() {
      try {
        const response = await this.loadRentalcompanyCodes('AC');
        this.reasonCodeOptions = response.data;
        this.asOptions.reasonCodeOptions = response.data;
      } catch (e) {
        //do nothing.
      }
    },

    /**
     * AS처리유형 로드
     */
    async loadOptionsForDoneReasonCode() {
      try {
        const response = await this.loadRentalcompanyCodes('AS');
        this.doneReasonCodeOptions = response.data;
        this.asOptions.doneReasonCodeOptions = response.data;
      } catch (e) {
        //do nothing.
      }
    },

    /**
     * 접수구분 로드
     */
    async loadOptionsForAsReceiptType() {
      try {
        const response = await this.loadRentalcompanyCodes("ART");
        this.asReceiptTypeOptions = response.data;
        this.asOptions.asReceiptTypeOptions = response.data;
      } catch (e) {
        //do nothing.
      }
    },

    /**
     * AS진행상태 로드
     */
    async loadOptionsForWorkorderState() {
      try {
        const response = await this.loadCodes("ST");
        this.workorderStateOptions = response.data;
        this.asOptions.workorderStateOptions = response.data;
      } catch (e) {
        //do nothing.
      }
    },

    /**
     * AS기사 로드
     */
    async loadOptionsForWorkorderStaff() {
      try {
        const response = await this.$request(PATH.USER.EMPLOYEE.LIST)
          .post()
          .enqueue();
        this.workorderStaffOptions = response.data;
        this.asOptions.workorderStaffOptions = response.data;
      } catch (e) {
        //do nothing.
      }
    },

    async loadCodes(codeType) {
      return this.$request(PATH.OPTIONS.BASE)
        .setObject({codeType: codeType.toUpperCase()})
        .enqueue();
    },

    async loadRentalcompanyCodes(codeType) {
      return this.$request(PATH.RENTALCOMPANY_CODES.BASE)
        .setObject({codeType: codeType})
        .enqueue();
    },


    /**
     * CMS 상태 로드
     */
    async loadCmsStateOptions() {
      this.cmsStateOptions = [
        {codeValue: this.t('전체'), codeKey: "null"},
        {codeValue: this.t('사용중'), codeKey: "Y"},
        {codeValue: this.t('해지'), codeKey: "N"},
        {codeValue: this.t('처리중'), codeKey: "R"},
        {codeValue: this.t('일시정지'), codeKey: "P"}
      ];
    },
    /**
     * 세금계산서 로드
     */
    async loadAutoIssueYnOptions() {
      this.autoIssueYnOptions = [
        {codeValue: this.t('전체'), codeKey: "null"},
        {codeValue: this.t('사용'), codeKey: "Y"},
        {codeValue: this.t('미사용'), codeKey: "N"}
      ];
    },
    /**
     * 거래처관리 부분에서 계약상태 로드 옵션
     */
    async loadUseYnOptions() {
      this.useYnOptions = [
        {codeValue: this.t('일시정지'), codeKey: "C"},
        {codeValue: this.t('계약중'), codeKey: "Y"},
        {codeValue: this.t('계약해지'), codeKey: "N"}
      ];
    },


    /**
     * 결제일 로드,계산시작일,세금계산서 발행일, 거래명세표 발행일
     *
     */
    async loadBillDayOnlyNumberOptions() {
      this.billDayOnlyNumberOptions = [
        {codeValue: 1, codeKey: 1},
        {codeValue: 2, codeKey: 2},
        {codeValue: 3, codeKey: 3},
        {codeValue: 4, codeKey: 4},
        {codeValue: 5, codeKey: 5},
        {codeValue: 6, codeKey: 6},
        {codeValue: 7, codeKey: 7},
        {codeValue: 8, codeKey: 8},
        {codeValue: 9, codeKey: 9},
        {codeValue: 10, codeKey: 10},
        {codeValue: 11, codeKey: 11},
        {codeValue: 12, codeKey: 12},
        {codeValue: 13, codeKey: 13},
        {codeValue: 14, codeKey: 14},
        {codeValue: 15, codeKey: 15},
        {codeValue: 16, codeKey: 16},
        {codeValue: 17, codeKey: 17},
        {codeValue: 18, codeKey: 18},
        {codeValue: 19, codeKey: 19},
        {codeValue: 20, codeKey: 20},
        {codeValue: 21, codeKey: 21},
        {codeValue: 22, codeKey: 22},
        {codeValue: 23, codeKey: 23},
        {codeValue: 24, codeKey: 24},
        {codeValue: 25, codeKey: 25},
        {codeValue: 26, codeKey: 26},
        {codeValue: 27, codeKey: 27},
        {codeValue: 28, codeKey: 28},
        {codeValue: 29, codeKey: 29},
        {codeValue: 30, codeKey: 30},
        {codeValue: 31, codeKey: 31},
      ];
    },
    /**
     * 지도표시 가능 여부 로드
     */
    async loadMapYnOptions() {
      this.mapYnOptions = [
        {codeValue: this.t('가능'), codeKey: "Y"},
        {codeValue: this.t('불가능'), codeKey: "N"}
      ];
    },
    /**
     * 지불방법 로드
     */
    async loadPayTypeOptions() {
      this.payTypeOptions = [
        {codeValue: this.t('CMS_출금'), codeKey: "B"},
        {codeValue: this.t('카드출금'), codeKey: "C"},
        {codeValue: this.t('기타수납'), codeKey: "E"}
      ];
    },

    /**
     * 프린터 상태 코드 로드
     */
    async loadPrinterStateCodes() {
      // 실제로 서버에서 로드하는 코드로 대체해야 합니다.
      this.printerStateOptions = [
        {codeValue: this.t('정상'), codeKey: "01"},
        {codeValue: this.t('잉크부족'), codeKey: "02"},
        {codeValue: this.t('프린터 오류'), codeKey: "03"},
        {codeValue: this.t('센서 오류'), codeKey: "04"},
        {codeValue: this.t('프린터 통신 오류'), codeKey: "05"},
        {codeValue: this.t('장비 통신 오류'), codeKey: "08"},
        {codeValue: this.t('알수 없는 오류'), codeKey: "99"}
      ];
    },

    /**
     * 무한 잉크 옵션 로드
     */
    async loadUnlimitedInkYnOptions() {
      this.unlimitedInkYnOptions = [
        {codeValue: this.t('전체'), codeKey: "null"},
        {codeValue: this.t('무한잉크 사용'), codeKey: "Y"},
        {codeValue: this.t('무한잉크 미사용'), codeKey: "N"},
      ];
    },

    /**
     * 토너 옵션 로드
     */
    async loadPmChkTonerOptions() {
      this.pmChkTonerOptions = [
        {codeValue: this.t('전체'), codeKey: "null"},
        {codeValue: this.t('드럼 체크'), codeKey: "Y"},
        {codeValue: this.t('드럼 미체크'), codeKey: "N"},
      ];
    },

    /**
     * 드럼 옵션 로드
     */
    async loadPmChkDrumOptions() {
      this.pmChkDrumOptions = [
        {codeValue: this.t('전체'), codeKey: "null"},
        {codeValue: this.t('드럼 체크'), codeKey: "Y"},
        {codeValue: this.t('드럼 미체크'), codeKey: "N"},
      ];
    },

    /**
     * 계약 여부 옵션 로드
     */
    async loadIsPrinterContractOptions() {
      this.isPrinterContractOptions = [
        {codeValue: this.t('전체'), codeKey: "null"},
        {codeValue: this.t('계약중'), codeKey: "true"},
        {codeValue: this.t('계약해지'), codeKey: "false"},
      ];
    },

    /**
     * 모니터링 여부 옵션 로드
     */
    async loadIsMonitoringPrinterOptions() {
      this.isMonitoringPrinterOptions = [
        {codeValue: this.t('전체'), codeKey: "null"},
        {codeValue: this.t('모니터링중'), codeKey: "true"},
        {codeValue: this.t('모니터링 중지'), codeKey: "false"},
      ];
    },

    /**
     *  출고 여부 옵션 로드
     */
    async loadInstallStatusOptions() {
      this.installStatusOptions = [
        {codeValue: this.t('전체'), codeKey: "null"},
        {codeValue: this.t('출고'), codeKey: "Y"},
        {codeValue: this.t('출고전'), codeKey: "N"},
      ];
    },
    /**
     *  출고 여부 옵션 로드
     */
    async loadDeviceInstallStatusOptions() {
      this.deviceInstallStatusOptions = [
        {codeValue: this.t('거래처 연결됨 '), codeKey: "Y"},
        {codeValue: this.t('거래처 연결안됨 '), codeKey: "N"},
      ];
    },

    /**
     * 장치 구분 옵션 로드
     */
    async loadDeviceTypeOptions() {
      this.deviceTypeOptions = [
        {codeValue: this.t('전체'), codeKey: "null"},
        {codeValue: this.t('PC에이전트'), codeKey: "PC"},
        {codeValue: this.t('실물콘솔'), codeKey: "DV"},
      ];
    },
    /**
     * 장치목록 -> 장치 구분 옵션 로드
     */
    async loadNewDeviceTypeOptions() {
      this.newDeviceTypeOptions = [
        {codeValue: this.t('PC'), codeKey: "PC"},
        {codeValue: this.t('Device'), codeKey: "DV"},
      ];
    },

    /**
     * 접속 상태 옵션 로드
     */
    async loadConnectionStatusOptions() {
      this.connectionStatusOptions = [
        {codeValue: this.t('전체'), codeKey: "null"},
        {codeValue: this.t('접속중'), codeKey: "1"},
        {codeValue: this.t('연결끊어짐'), codeKey: "0"},
      ];
    },

    /**
     * 공지사항 종류 로드
     */
    async loadNoticeTypeOptions() {
      const response = await this.$request(PATH.BOARD.TYPE.LIST).setObject({boardTypeCd: 'N'}).enqueue()
      console.log("loadNoticeTypeOptions : ", response)
      this.noticeTypeOptions = response.data.map(data => {
        return {codeValue: this.t(data.boardTypeName), codeKey: data.boardTypeId}
      })
    },

    /**
     * 상세 여부 로드
     */
    async loadNoticeDetailOptions() {
      this.noticeDetailOptions = [
        {codeValue: this.t('상세'), codeKey: 'Y'},
        {codeValue: this.t('일반'), codeKey: 'N'},
      ]
    },

    /**
     * FAQ 종류 로드
     */
    async loadFAQTypeOptions() {
      const response = await this.$request(PATH.BOARD.TYPE.LIST).setObject({boardTypeCd: 'F'}).enqueue()
      console.log("loadFAQTypeOptions : ", response)
      this.faqTypeOptions = response.data.map(data => {
        return {codeValue: this.t(data.boardTypeName), codeKey: data.boardTypeId}
      })
    },

    /**
     * FAQ 상세 여부 로드
     */
    async loadFAQDetailOptions() {
      this.faqDetailOptions = [
        {codeValue: this.t('상세'), codeKey: 'Y'},
        {codeValue: this.t('일반'), codeKey: 'N'},
      ]
    },


    /**
     * 상세 여부 로드
     */
    async loadBatchOptions() {
      this.batchOptions = [
        {codeValue: '배치 종료 여부', codeKey: 'F'},
        {codeValue: '중복 매출', codeKey: 'B'},
        {codeValue: '누락 매출', codeKey: 'BO'},
        {codeValue: '세금계산서', codeKey: 'T'},
        {codeValue: '누락 CMS', codeKey: 'C'},
        {codeValue: '중복 CMS', codeKey: 'CD'},
        {codeValue: '실패 목록', codeKey: 'FL'},
        {codeValue: '월별 사용량', codeKey: 'US'},
      ]
    },
    /**
     * 매출확인 로드
     */
    async loadPaymentMethodOptions() {
      this.paymentMethodOptions = [
        {codeValue: 'CMS(이체)', codeKey: 'C'},
        {codeValue: 'CMS(카드)', codeKey: 'B'},
        {codeValue: '기타 수납', codeKey: 'E'},
      ]
    },

    /**
     * 삭제여부
     */

    async loadDeleteYnOptions() {
      this.deleteYnOptions = [
        {codeValue: '사용중', codeKey: 'N'},
        {codeValue: '삭제', codeKey: 'Y'},
      ]
    },
    /**
     * 장치목록 삭제여부
     */

    async loadDeviceDeleteYnOptions() {
      this.deviceDeleteYnOptions = [
        {codeValue: '삭제', codeKey: 'Y'},
        {codeValue: '미삭제', codeKey: 'N'},
      ]
    },


    async loadPaymentStatusOptions() {
      this.paymentStatusOptions = [
        {codeValue: '완납', codeKey: 'Y'},
        {codeValue: '과납', codeKey: 'O'},
        {codeValue: '미납', codeKey: 'N'},
      ]
    },
    async loadCmsOptions() {
      this.cmsOptions = [
        {codeValue: '성공', codeKey: 'Y'},
        {codeValue: '실패', codeKey: 'N'},
      ]
    },
    async loadSalesTypeOptions() {
      this.salesTypeOptions = [
        {codeValue: '정기', codeKey: 'P'},
        {codeValue: '수납조정', codeKey: 'M'},
        {codeValue: '선납매출', codeKey: 'F'},
        {codeValue: '비정기', codeKey: 'N'},
      ]
    },
    async loadCommandTypeOptions() {
      this.commandTypeOptions = [
        {codeValue: '프린터 헤드 정렬 [1]', codeKey: 1},
        {codeValue: '프린터 헤드 청소 [2]', codeKey: 2},
        {codeValue: '프린터 라인 피드 [3]', codeKey: 3},
        {codeValue: '테스트 페이지 출력 [4]', codeKey: 4},
        {codeValue: '프린터 재 시작 [6]', codeKey: 6},
        {codeValue: '프린터 등록 [100]', codeKey: 100},
        {codeValue: '프린터 삭제 [101]', codeKey: 101},
        {codeValue: '프린터 등록 목록 동기화 [105]', codeKey: 105},
        {codeValue: '프린터 enable [302]', codeKey: 302},
        {codeValue: '프린터 disable [303]', codeKey: 303},
        {codeValue: '프린터 검색 [304]', codeKey: 304},
        {codeValue: '장치 설정 정보 가져오기 [401]', codeKey: 401},
        {codeValue: '장치 설정 정보 저장 [402]', codeKey: 402},
        {codeValue: '장치 모니터링 로그 가져오기 [411]', codeKey: 411},
        {codeValue: '장치 업데이트 로그 가져오기 [412]', codeKey: 412},
        {codeValue: '장치 APP LOG 가져오기 [413]', codeKey: 413},
        {codeValue: 'SNMP 원격 수집 [901]', codeKey: 901},
      ]
    },

    async loadCompanyOptions() {
      await this.$request(PATH.MEMBERSHIP.LIST)
        .get()
        .catch(e => {
          alert('조회실패')
        })
        .enqueue()
        .then(res => {
          const companyArr = res.data.map((
            {rentalcompany_id, rentalcompany_name}) => {
            return {codeKey: rentalcompany_id, codeValue: `${rentalcompany_id} [${rentalcompany_name}]`}
          })
          this.companyOptions = [...companyArr];
        });
    },

    // 입대업체 그룹 옵션
    async loadRentalCompanyGroupOptions() {
      const res = await this.$request(PATH.RANTALCOMPANY_GROUP.LIST)
        .get()
        .enqueue()

      this.rentalCompanyGroupOptions = res.data.map(m => {
        return {
          codeKey: m.rentalcompanyGroupId,
          codeValue: m.groupName
        }
      })
    },
  },
}
</script>
